import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { Checkbox } from "primereact/checkbox";
import { sanitizePhoneNumber } from "../../../utils/validation";
import { getCompany } from "../../../config/companyConfig";

const PersonalInfoForm = ({
  clientData,
  clientInfo,
  isLoadingClientInfo,
  perfilForm,
  personalForm,
  isSavingPersonal,
  onUpdateField,
  onSave,
  marketingAccepted,
  onMarketingChange,
}) => (
  <div className="flex flex-column gap-3">
    <Card title="Datos de la empresa">
      {isLoadingClientInfo ? (
        <p className="admin-text-sm">Cargando información...</p>
      ) : (
        <div className="flex flex-column gap-3">
          <div className="flex align-items-center gap-3">
            <label className="w-3 font-bold admin-text-base">
              Razón Social:
            </label>
            <InputText
              value={clientData?.razonSocial || "-"}
              disabled
              className="flex-1"
            />
          </div>
          <div className="flex align-items-center gap-3">
            <label className="w-3 font-bold admin-text-base">RUT:</label>
            <InputText
              value={clientInfo?.rut || "-"}
              disabled
              className="flex-1"
            />
          </div>
          <div className="flex align-items-center gap-3">
            <label className="w-3 font-bold admin-text-base">Dirección:</label>
            <InputText
              value={clientData?.direccion || "-"}
              disabled
              className="flex-1"
            />
          </div>
        </div>
      )}
    </Card>

    <Card title="Datos personales">
      <div className="flex flex-column gap-3">
        <div className="flex align-items-center gap-3">
          <label className="w-3 font-bold admin-text-base">Perfil:</label>
          <InputText
            value={perfilForm.descripcion}
            className="flex-1"
            disabled
          />
        </div>
        <div className="flex align-items-center gap-3">
          <label className="w-3 font-bold admin-text-base">Nombre *</label>
          <InputText
            value={personalForm.nombre}
            onChange={(e) => onUpdateField("nombre", e.target.value)}
            required
            aria-required="true"
            className="flex-1"
          />
        </div>
        <div className="flex align-items-center gap-3">
          <label className="w-3 font-bold admin-text-base">
            Teléfono/Celular *
          </label>
          <InputText
            value={personalForm.telefono}
            onChange={(e) =>
              onUpdateField("telefono", sanitizePhoneNumber(e.target.value))
            }
            inputMode="numeric"
            maxLength={11}
            placeholder="Máximo 11 números"
            required
            aria-required="true"
            className="flex-1"
          />
        </div>
        <div className="flex align-items-center gap-3">
          <label className="w-3 font-bold admin-text-base">Correo *</label>
          <InputText
            value={personalForm.email}
            onChange={(e) => onUpdateField("email", e.target.value)}
            type="email"
            placeholder="correo@dominio.cl"
            required
            aria-required="true"
            className="flex-1"
          />
        </div>
      </div>
      <div className="flex gap-2 mt-3">
        <Button
          label={isSavingPersonal ? "Guardando..." : "Guardar"}
          onClick={onSave}
          disabled={isSavingPersonal}
          size="small"
          severity="success"
          icon="pi pi-save"
        />
        <Button
          label="Descargar términos y condiciones"
          onClick={() =>
            window.open(getCompany().termsUrl, "_blank", "noopener,noreferrer")
          }
          size="small"
          severity="info"
          icon="pi pi-download"
        />
        <div className="flex align-items-center gap-2">
          <Checkbox
            inputId="marketing-acceptance"
            checked={Boolean(marketingAccepted)}
            onChange={(e) => onMarketingChange?.(e.checked)}
          />
          <label
            htmlFor="marketing-acceptance"
            className="text-sm cursor-pointer"
          >
            Acepto recibir información y promociones de marketing
          </label>
      </div>
      </div>
      
    </Card>
  </div>
);

export default PersonalInfoForm;
